import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'
import Paper from '@/components/Paper'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import type { DataTableColumn } from '@/components/ui/data-table-customized'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { SalesTargetFilters } from '@/modules/Report/components/BusinessTargets/types'
import { EmployeeBasicInfo, getEmployeesByIds } from '@/modules/Report/services'

interface EmployeeTableProps {
    filters: SalesTargetFilters
}

export default function EmployeeTable({ filters }: EmployeeTableProps) {
    const { t } = useTranslation('report')

    const { data: employees, renderState } = useQueryWithHandler({
        queryKey: [
            QUERY_KEYS.EMPLOYEES,
            'target-analytics',
            filters.employee_id,
        ],
        queryFn: () => getEmployeesByIds(filters.employee_id ?? []),
        enabled: !!filters.employee_id?.length,
    })

    const columns: DataTableColumn<EmployeeBasicInfo>[] = useMemo(
        () => [
            {
                key: 'employee_name',
                title: t('target_analytics.table.employees.name', 'Nhân viên'),
                width: 200,
            },
            {
                key: 'department_name',
                title: t('department', 'Phòng ban'),
                width: 150,
            },
        ],
        [t]
    )

    const stateComponent = renderState()

    return (
        <Paper className="h-full flex flex-col gap-4">
            <Typogaphy className="text-sm font-medium text-[#1A237E]">
                {t('target_analytics.employee_monitoring.title')}
            </Typogaphy>
            {stateComponent || (
                <DataTableCustomized<EmployeeBasicInfo>
                    columns={columns}
                    rows={employees ?? []}
                    rowKey={(row) => row.employee_id}
                    size="small"
                />
            )}
        </Paper>
    )
}
